import MovieActions from './MovieActions'
import MovieDetails from './MovieDetails'
import MovieInfos from './MovieInfos'
import MovieOverview from './MovieOverview'
import MoviePoster from './MoviePoster'
import MovieRoot from './MovieRoot'

export const Movie = {
  Root: MovieRoot,
  Actions: MovieActions,
  Infos: MovieInfos,
  Details: MovieDetails,
  Overview: MovieOverview,
  Poster: MoviePoster,
}
